import type { TrainingIntegrationAgent } from '../types/api';

/** GET /training/integrations/{id}/agents — array or `{ items: [] }`. */
export function normalizeTrainingIntegrationAgents(data: unknown): TrainingIntegrationAgent[] {
  if (Array.isArray(data)) {
    return data as TrainingIntegrationAgent[];
  }
  if (data && typeof data === 'object' && Array.isArray((data as { items?: unknown }).items)) {
    return (data as { items: TrainingIntegrationAgent[] }).items;
  }
  return [];
}

export function buildIntegrationAgentsByName(data: unknown): Record<string, string> {
  const map: Record<string, string> = {};
  for (const row of normalizeTrainingIntegrationAgents(data)) {
    const id = (row.agent_id || row.id || '').trim();
    const name = (row.agent_name || row.name || '').trim();
    if (id && name) map[name.toLowerCase()] = id;
  }
  return map;
}
